/**
 * Conjunto de estilos para los diferentes tamaño de pantalla
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class StyleSet {
    [key: string]: MenuStyle
}


/**
 * Configuración de estilos de menú
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class MenuStyle {
    public fontColor = ''
    public fontSize = ''
    public hoverFontColor = ''
}
